
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from 'element-react';
require ("./index.scss");
class Paging extends Component {
    constructor(props) {
        super(props);
        this.state = {
            msg: '子组件传值给父组件'
        };

    }
    onSizeChange(e){
        // this.props.onsubmit
        console.log("分页e:",e);
    }

    onCurrentChange(data){
     this.props.onCurrentChange&&this.props.onCurrentChange(data);
    }
   
    render() {
        let {total, pageSize, currentPage, showSizes} = this.props;
        // 军旅文化传showSizes过来，showSizes为true时，不显示条/页
        return (

            <div className="pagination_bottom" style={{textAlign:'center'}}>
                {
                    showSizes && showSizes ? <Pagination layout="total, prev, pager, next, jumper" total={total} pageSize={pageSize} currentPage={currentPage} onCurrentChange={this.onCurrentChange.bind(this)}/>:
                    <Pagination layout="total, sizes, prev, pager, next, jumper" total={total} pageSize={pageSize} currentPage={currentPage} onCurrentChange={this.onCurrentChange.bind(this)}/>
                }
                {/* <Pagination layout="total, sizes, prev, pager, next, jumper" total={400} pageSizes={[100, 200, 300, 400]} pageSize={100} currentPage={5}/> */}
            </div>
        )
    }
}

export default Paging;